// extracted by mini-css-extract-plugin
export default {"name":"TeamMemberName_name__HdHmw"};